// Module
var code = "<textarea class=\"form-control\" ng-model=\"vm.value\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\"></textarea> ";
// Exports
module.exports = code;